import React from 'react';
import {Stack} from '@mui/material';
import {
  Modal,
  Button,
  Headline,
  Body,
  designSystemToken,
} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import {
  RESIZE_PLAYGROUND_URL,
  RESIZE_CONTACT_SALES_URL,
} from '@/types/postProductionGeneration';

export type ResizeLimitModalProps = {
  testID?: string;
  open: boolean;
  onClose: () => void;
  onPlaygroundClick?: () => void;
  onContactSalesClick?: () => void;
};

function ResizeLimitModal({
  testID = 'resize-limit-modal',
  open,
  onClose,
  onPlaygroundClick,
  onContactSalesClick,
}: ResizeLimitModalProps) {
  const handleOpenPlayground = () => {
    onPlaygroundClick?.();
    window.open(RESIZE_PLAYGROUND_URL, '_blank', 'noopener,noreferrer');
  };

  const handleContactSales = () => {
    onContactSalesClick?.();
    window.open(RESIZE_CONTACT_SALES_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <Modal open={open} handleClose={onClose} size="large" showCloseButton>
      <Stack
        gap="16px"
        padding="24px"
        alignItems="center"
        sx={{width: '100%', textAlign: 'center'}}
        data-testid={testID}
      >
        <Headline size="md">{translate('Resize limit reached')}</Headline>
        <Body size="md" color={designSystemToken('semantic.fg.secondary')}>
          {translate(
            "You've used all the resizes available for this campaign. Need more? Contact sales to raise your limit, or keep resizing in the LTX Playground."
          )}
        </Body>

        <Stack
          direction="row"
          justifyContent="center"
          flexWrap="wrap"
          gap="12px"
          sx={{width: '100%'}}
        >
          <Button
            mode="tinted"
            appearance="brand"
            size="medium"
            onClick={handleContactSales}
          >
            {translate('Contact Sales')}
          </Button>
          <Button
            mode="filled"
            appearance="brand"
            size="medium"
            onClick={handleOpenPlayground}
          >
            {translate('LTX Playground')}
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
}

export default ResizeLimitModal;
